import { JsonApiId } from '@one-vision/json-api-parser';
import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import RuleValues from 'core/redux/reducers/partnerGroupRuleValues';

export const deletePartnerRuleValue =
  (options: { id: JsonApiId }, listId?: string): AppThunk =>
  async (dispatch) => {
    try {
      await apiClient.deleteRuleValue(options);
      dispatch(RuleValues.actions.remove(options, listId));
    } catch (error) {
      console.error(error);
    }
  };
